import filter from 'lodash/filter'
import { computed, makeObservable } from 'mobx'

import type { Model } from 'modules/core/lib/mobx-rest'
import { Collection } from 'modules/core/lib/mobx-rest'

import Employee from 'modules/employees/store/models/Employee'

export class Employees extends Collection<Employee> {
  constructor(data: any = []) {
    super(data)

    makeObservable(this, {
      active: computed,
    })
  }

  get cacheKey(): string {
    return 'employees'
  }

  get indexes() {
    return ['access_id', 'manager_id', 'employee_group_id', 'location_id', 'timeoff_policy_id']
  }

  /**
   * @deprecated DO NOT USE THIS METHOD. Use GraphQL instead.
   */
  relatedTo(model: Model): Employee {
    const employeeId = model.attributes.employee_id
    const employee = this.get(employeeId)

    if (!employee) {
      throw Error(`Error getting employees with id = ${employeeId}`)
    }

    return employee
  }

  get active(): Employee[] {
    return filter(this.models, (model) => !model.isTerminated)
  }

  model() {
    return Employee
  }

  bulkUpdate(data: Record<string, unknown> | { changes: unknown[] }): Promise<unknown> {
    return this.rpc('bulk_update', data)
  }
}

const singleton: Employees = new Employees()

export default singleton
